<template>
  <transition name="Miniload">
    <div class="Miniload">
      <div class="Miniload__spin" />
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'Miniload'
  }
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Miniload
  position fixed
  top 50%
  left 50%
  background rgba(black, .7)
  height 50px
  width 50px
  transform translate(-50%, -50%)
  border-radius 10px
  transition opacity 1s
  z-index 99999999999999
  &-enter
  &-leave-active
    opacity 0

  &__spin
    position absolute
    top 50%
    left 50%
    margin -12px 0 0 -12px
    border 2px solid rgba(white, 1)
    border-top 2px solid rgba(white, .4)
    border-radius 50%
    width 20px
    height 20px
    animation Loader__spin 2s linear infinite

    @keyframes Capture__spin {
      from { transform: rotate(0deg) }
      to { transform: rotate(360deg) }
    }

</style>
